module.exports = __webpack_public_path__ + "add060b49403791a15c1f511c2580b84.jpg";